import {
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ErrorDialogServiceService } from './ErrorDialogService.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorDialogService: ErrorDialogServiceService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "An error occurred."; // Default message

        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.error) {
            errorMessage = error.error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }

        console.error("Intercepted error:", {
          status: error.status,
          message: error.message,
          backendMessage: error.error,
        });

        const suppressError = request.headers.get('X-Suppress-Error');
        if (!suppressError) {
          this.errorDialogService.openDialog(errorMessage);
        }

        return throwError(() => error);
      }),
      finalize(() => {
        // hide loading spinner
      })
    ) as Observable<HttpEvent<any>>;
  }

}
